"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withContentRefList = exports.ContentRefListContext = void 0;
var lodash_noop_1 = __importDefault(require("lodash.noop"));
var react_1 = __importStar(require("react"));
exports.ContentRefListContext = (0, react_1.createContext)({
    contentRefs: [],
    addContentRef: lodash_noop_1.default,
    removeContentRef: lodash_noop_1.default,
});
function ContentRefListProvider(_a) {
    var children = _a.children;
    var _b = (0, react_1.useContext)(exports.ContentRefListContext), superAddContentRef = _b.addContentRef, superRemoveContentRef = _b.removeContentRef;
    var _c = (0, react_1.useState)([]), contentRefs = _c[0], setContentRefs = _c[1];
    var addContentRef = (0, react_1.useCallback)(function (ref) {
        setContentRefs(function (prevContentRefs) { return __spreadArray(__spreadArray([], prevContentRefs, true), [ref], false); });
        superAddContentRef(ref);
    }, [superAddContentRef]);
    var removeContentRef = (0, react_1.useCallback)(function (ref) {
        setContentRefs(function (prevContentRefs) { return prevContentRefs.filter(function (prevRef) { return prevRef !== ref; }); });
        superRemoveContentRef(ref);
    }, [superRemoveContentRef]);
    return (react_1.default.createElement(exports.ContentRefListContext.Provider, { value: { contentRefs: contentRefs, addContentRef: addContentRef, removeContentRef: removeContentRef } }, children));
}
function withContentRefList(Component) {
    var Wrapped = function (props) { return (react_1.default.createElement(ContentRefListProvider, null,
        react_1.default.createElement(Component, __assign({}, props)))); };
    Wrapped.displayName = "ContentRefList<".concat(getDisplayName(Component), ">");
    return Wrapped;
}
exports.withContentRefList = withContentRefList;
function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
